import { isNull, isSameId } from "../../helpers";
export default function (store, { id, targetId, parent, reverse, project, join = false, }) {
    if (!store.existsTask(id))
        return;
    let copiedTasksId = [];
    if (join) {
        const copied = store.getState().copiedTasksId;
        const parents = store.getParentIds(id);
        if (copied.some(i => isSameId(i, id) || parents.some(p => isSameId(i, p))))
            return;
        const children = store.getChildrenIds({ id });
        for (let index = 0; index < copied.length; index++) {
            if (children.some(i => isSameId(i, copied[index]))) {
                copied.splice(index, 1);
            }
        }
        copiedTasksId = [...copied];
    }
    copiedTasksId.push(id);
    store.setState({ copiedTasksId });
    if (store.existsTask(targetId) ||
        store.existsTask(parent) ||
        isNull(parent)) {
        store.pasteTask({ targetId, parent, project, reverse });
    }
}
//# sourceMappingURL=copy.js.map